/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.applySearchParams();
      
      this.setAttribute('loaded', '');
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);
      // Simoni Added this function
      var opt = evt.srcElement.getAttribute('name');
      if (opt.includes('colour')) {
        this.updateColorSwatch(evt);
      }
      
      // End
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      this.addBtntext = this.addBtntext || this.productForm.querySelector('[name="add"] .text_btn_update');
      const variant = this.variant;
       const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      const preorderBtn = document.body.querySelector('.essential-preorder-container-active');
      const wishlistBtns = document.body.querySelectorAll('.swym-add-to-wishlist');
       const upon_img_icon = document.querySelector('.swym-wishlist-button-bar');
       const target__addtocart_upper = document.querySelector('.quantity-submit-row__submit');
    
       const inventoryContainer = this.productForm.querySelector('.inventory_quantity');
       let inventoryQuantity;
      let inventoryPolicy;
      if(variantAvailable){        
        if(inventoryContainer){
          const variantElement = inventoryContainer.querySelector(`span[data-vid="${variant.id}"]`);
          if (variantElement) {
                   inventoryQuantity = variantElement.getAttribute('data-inventoryQTY'); 
                   inventoryPolicy = variantElement.getAttribute('data-inventoryPolicy'); 
          }
        }   
      }

       const isPreorder = inventoryPolicy == 'continue' && inventoryQuantity == 0;
     
      if(isPreorder || !variantAvailable){
         wishlistBtns.forEach(btn => {
               btn.classList.add('hide-wishlist-btn');
            });
          if(target__addtocart_upper.classList.contains('addtocart-wishlist')){
            target__addtocart_upper.classList.remove('addtocart-wishlist');
          }
      }else{
         if(upon_img_icon && upon_img_icon.classList.contains('upon_image__icon')){
            upon_img_icon.classList.remove('upon_image__icon');
         }
         wishlistBtns.forEach(btn => {
               btn.classList.remove('hide-wishlist-btn');
            });
          if(target__addtocart_upper){
            target__addtocart_upper.classList.add('addtocart-wishlist');
          }
      }
   
      
        if(!variantAvailable){
        console.log('unavailable');
          if (preorderBtn) {
            preorderBtn.classList.add('preorder_btn_hide');
          }
            this.addBtn.classList.add('unavailable_btn');          
      }else{
        if (preorderBtn) {
          preorderBtn.classList.remove('preorder_btn_hide');
        }        
        this.addBtn.classList.remove('unavailable_btn');
           
      }
      
      this.addBtn.disabled = !variantAvailable;
      this.addBtntext.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;


       const quickBuyContainer = this.closest('.quickbuy-container');
      if (isPreorder && quickBuyContainer) {
        this.addBtn.classList.add('preorder__quickbuy_redirection');
        this.addBtntext.textContent =  'Preorder';
        if (variantAvailable) {
            this.addBtn.setAttribute('data-v', variant.id);
        }
      }else{
          this.addBtn.classList.remove('preorder__quickbuy_redirection');
         this.addBtn.removeAttribute('data-v');
      }
    
      
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    updateColorSwatch(evt){
      var colorimage = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      colorimage = colorimage.toUpperCase();
      
      var elements = document.querySelectorAll('[data-altcolor]');
      var fir = '';
      elements.forEach(function(element) {
        var altcolorValue = element.getAttribute('data-altcolor');
        altcolorValue = altcolorValue.toUpperCase();
        if(altcolorValue!=colorimage && altcolorValue!='MAIN-IMAGE'){
          element.setAttribute('hidden','');
        }
        else{
          element.removeAttribute('hidden');            
        }
        
      });
       var elements2 = document.querySelectorAll('[data-altcolorthumb]');
      var first = '';
      elements2.forEach(function(elementsmall) {
        
        var altcolorValue2 = elementsmall.getAttribute('data-altcolorthumb');
        altcolorValue2 = altcolorValue2.toUpperCase();
        if(altcolorValue2!=colorimage && altcolorValue2!='MAIN-IMAGE'){
          elementsmall.setAttribute('hidden','');
        }
        else{
          if(first==''){
           first = elementsmall;
          }
          elementsmall.removeAttribute('hidden');
       
        }
      });
    
    }
 static updateLabelText(evt) {
        const selector = evt.target.closest('.option-selector');
        if (selector.dataset.selectorType === 'dropdown') return;

        const colorText = selector.querySelector('.js-color-text');
        if (!colorText) return;

        const selectedValue = evt.target.nextElementSibling.querySelector('.js-value').textContent;

        const colorWrapper = evt.target.closest('.separater_for_color');
        if (!colorWrapper) return;

        const fieldset = selector;
        const separateCount = parseInt(fieldset.dataset.separatecount, 10);
        const forIndex = parseInt(colorWrapper.dataset.forindex, 10);
        if(document.querySelector('.title_of_fashion_color span')) {
          if (colorWrapper.classList.contains("color_separation") && forIndex >= separateCount) {
            document.querySelector('.title_of_fashion_color span').innerHTML = selectedValue;
            colorText.style.display = "none";
          } else {
            colorText.textContent = selectedValue;
            colorText.style.display = "inline-block";

              document.querySelector('.title_of_fashion_color span').innerHTML = '';

          }
        }
    }


   
    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;
      
      if (this.variant && this.variant.available) {
        if (typeof this.pickUpAvailability.getAvailability === 'function') {

        this.pickUpAvailability.getAvailability(this.variant.id);
        }
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
   updatePrice() {
      this.priceElements = this.section.querySelectorAll('.product-price .price');
      if (!this.priceElements.length) return;
    
      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        }
      }
    
      this.priceElements.forEach(priceElement => {
        if (variant) {
          const priceCurrentEl = priceElement.querySelector('.price__current');
          const priceWasEl = priceElement.querySelector('.price__was');
          const unitPriceEl = priceElement.querySelector('.unit-price');

          const secondPrice = document.querySelector('.covered_qty_inventory .price__current');
          const wasprice = document.querySelector('.covered_qty_inventory .price__was');
         
    
          // Update current price and original price if on sale.
           const currentPrice = parseFloat(this.data.formatted[variant.id].price.replace(/[^\d.-]/g, '')); 
           const quantityInput = this.section.querySelector('[name="quantity"]');
          const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
            
           const updatedPrice = (currentPrice * quantity).toFixed(2);
          const currencySymbol = priceCurrentEl.dataset.symbol
          
          priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
          priceCurrentEl.dataset.price = currentPrice;
          if(secondPrice){
            secondPrice.innerHTML = `${currencySymbol}${updatedPrice}`;
          }
           if (priceWasEl) {
                const comparePrice = parseFloat(this.data.formatted[variant.id].compareAtPrice?.replace(/[^\d.-]/g, '')) || null;
        
                // Only update wasprice if comparePrice has a valid value
                if (comparePrice) {
                  const updatedComPrice = (comparePrice * quantity).toFixed(2);
                  priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice;
                  priceWasEl.dataset.compare = comparePrice;
                  if (wasprice) {
                    wasprice.innerHTML = `${currencySymbol}${updatedComPrice}`;
                  }
                } else {
                  // Clear wasprice if no compare price data is available
                  if (wasprice) wasprice.innerHTML = '';
                }
          }
          
          // Update unit price, if specified.
          if (variant.unit_price_measurement) {
            const valueEl = priceElement.querySelector('.unit-price__price');
            const unitEl = priceElement.querySelector('.unit-price__unit');
            const value = variant.unit_price_measurement.reference_value;
            const unit = variant.unit_price_measurement.reference_unit;
    
            valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
            unitPriceEl.hidden = false;
          } else if (unitPriceEl) {
            unitPriceEl.hidden = true;
          }
    
          // Update sale and sold-out classes
          priceElement.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
          priceElement.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
        }
    
        priceElement.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
        if(priceElement.querySelector('.price__no-variant')){
          priceElement.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
        }
        const from = priceElement.querySelector('.price__from');
        if (from) {
          from.hidden = !this.preSelection;
        }
      });
  }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }
     applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);
      
      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
       
        const optionSelectors = Array.from(this.optionSelectors);
        
        const matchingOptionSelector = optionSelectors.find((x) => x.dataset.option === key);
        
        if (!matchingOptionSelector) return;

        if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
          
          const colorOptionDropdown = matchingOptionSelector.querySelector(`.custom-select__option[data-value="${value}"]`);
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest('custom-select');
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          
          const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
          
          if (matchingInput) {
          
            const matchingOptionValue = matchingOptionSelector.querySelector('.option-selector__label-value');
            if (matchingOptionValue) {
             
              matchingOptionSelector.querySelector('.option-selector__label-value').textContent = value;
            }
            matchingInput.checked = true;
            
            matchingInput.dispatchEvent(
              new CustomEvent('change', { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }
  }
  
  customElements.define('variant-picker', VariantPicker);
}
